/*
  Custom product media gallery behaviour. Plain functions called directly
  from onclick/onmousemove attributes in the markup - no event delegation,
  no listener binding, nothing that depends on script/DOM load order.
*/

function customGallerySelectThumb(btn) {
  var gallery = btn.closest('.custom-media-gallery');
  var frame = gallery.querySelector('[data-main-frame]');
  gallery.querySelectorAll('.custom-media-thumb').forEach(function (t) {
    t.classList.remove('is-active');
  });
  btn.classList.add('is-active');

  if (btn.dataset.mediaType === 'video') {
    var template = gallery.querySelector('[data-video-template]');
    frame.innerHTML = '';
    frame.appendChild(template.content.cloneNode(true));
    return;
  }

  var mainImg = frame.querySelector('[data-main-img]');
  if (!mainImg) {
    // Frame currently shows the video from a previous selection - rebuild the <img>.
    frame.innerHTML = '<img class="custom-media-img" data-main-img draggable="false">';
    mainImg = frame.querySelector('[data-main-img]');
  }
  // srcset takes precedence over src, so it MUST be replaced too -
  // updating src alone changes the DOM property but not the rendered image.
  mainImg.srcset = btn.getAttribute('data-srcset') || '';
  mainImg.src = btn.getAttribute('data-full');
  mainImg.alt = btn.getAttribute('data-alt') || '';
}

function customGalleryZoomMove(frame, event) {
  var img = frame.querySelector('[data-main-img]');
  if (!img) return; // video is showing - no zoom
  var rect = frame.getBoundingClientRect();
  var x = ((event.clientX - rect.left) / rect.width) * 100;
  var y = ((event.clientY - rect.top) / rect.height) * 100;
  img.style.transformOrigin = x + '% ' + y + '%';
  frame.classList.add('is-zooming');
}

function customGalleryZoomOut(frame) {
  frame.classList.remove('is-zooming');
}

function customGalleryScrollThumbs(btn, direction) {
  var wrap = btn.closest('.custom-media-thumbs-wrap');
  var track = wrap.querySelector('[data-thumbs-track]');
  var thumb = track.querySelector('[data-thumb]');
  var thumbWidth = thumb ? thumb.getBoundingClientRect().width : 80;
  track.scrollBy({ left: direction * (thumbWidth + 14) * 2, behavior: 'smooth' });
}

function customGalleryUpdateArrows(track) {
  var wrap = track.closest('.custom-media-thumbs-wrap');
  var prevBtn = wrap.querySelector('[data-thumbs-prev]');
  var nextBtn = wrap.querySelector('[data-thumbs-next]');
  var maxScroll = track.scrollWidth - track.clientWidth;
  prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 2);
  nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll - 2);
}
